module.exports = "<div class=\"em-dialog hide\"> <div class=\"footer hide\"> <button class=cancel-btn>取消</button> <button class=\"confirm-btn bg-color\"></button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/common/uikit/template/dialogTpl.html
// module id = 218
// module chunks = 0